// pages/Admin/AdminDashboard.jsx (Updated with role check)
import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Common/Layout';
import OrdersManager from './OrdersManager';
import ProductManager from './ProductManager';
import ReviewManager from './ReviewManager';
import HomeContentManager from './HomeContentManager';
import '../styles/Admin.css';

const AdminDashboard = () => {
    const [activeTab, setActiveTab] = useState('products');
    const [message, setMessage] = useState('');
    const { currentUser, isAdmin } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (currentUser && !isAdmin()) {
            navigate('/', { replace: true });
        }
    }, [currentUser, isAdmin, navigate]);

    if (!currentUser || !isAdmin()) {
        return (
            <div className="container py-5 text-center">
                <div className="alert alert-warning">
                    <h3>Access Denied</h3>
                    <p>You don't have permission to access the admin dashboard.</p>
                </div>
            </div>
        );
    }

    return (
        <Layout>
            <div className="admin-dashboard">
                <div className="container">
                    <div className="admin-header">
                        <h1>Admin Dashboard</h1>
                        <p>Manage products, orders, inventory, and reviews</p>
                        <small className="text-muted">
                            Logged in as: {currentUser.email} (Admin)
                        </small>
                    </div>

                    {/* Navigation Tabs */}
                    <div className="admin-tabs">
                        <button
                            className={activeTab === 'home' ? 'active' : ''}
                            onClick={() => setActiveTab('home')}
                        >
                            <span className="tab-icon">🏠</span>
                            <span className="tab-text">Home Page</span>
                        </button>
                        <button
                            className={activeTab === 'products' ? 'active' : ''}
                            onClick={() => setActiveTab('products')}
                        >
                            <span className="tab-icon">🛍️</span>
                            <span className="tab-text">Products</span>
                        </button>
                        <button
                            className={activeTab === 'orders' ? 'active' : ''}
                            onClick={() => setActiveTab('orders')}
                        >
                            <span className="tab-icon">📦</span>
                            <span className="tab-text">Orders</span>
                        </button>
                        <button
                            className={activeTab === 'reviews' ? 'active' : ''}
                            onClick={() => setActiveTab('reviews')}
                        >
                            <span className="tab-icon">⭐</span>
                            <span className="tab-text">Reviews</span>
                            <span className="badge" id="pending-reviews-badge">0</span>
                        </button>
                    </div>

                    {/* Tab Content */}
                    <div className="admin-content">
                        {activeTab === 'products' && <ProductManager setMessage={setMessage} />}
                        {activeTab === 'orders' && <OrdersManager setMessage={setMessage} />}
                        {activeTab === 'reviews' && <ReviewManager setMessage={setMessage} />}
                        {activeTab === 'home' && <HomeContentManager setMessage={setMessage} />}
                    </div>

                    {message && (
                        <div className="admin-message">
                            <span>{message}</span>
                            <button onClick={() => setMessage('')}>×</button>
                        </div>
                    )}
                </div>
            </div>
        </Layout>
    );
};

export default AdminDashboard;